"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIcon = exports.createUrlWithUtmParameters = exports.getShareUrl = void 0;
const fdr_share_form_constants_1 = require("./fdr-share-form.constants");
const addUtmParametersToUrl = ({ shareUrl, utmMedium, channelUtm, }) => {
    var _a;
    const url = new URL(shareUrl);
    url.searchParams.append(`utm_source`, ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname) || '');
    url.searchParams.append(`utm_medium`, utmMedium);
    url.searchParams.append(`channel`, channelUtm);
    return url.href;
};
function getShareUrl({ source, title, shareUrl, email, channelType, }) {
    if (!fdr_share_form_constants_1.shareLinks[source])
        return '';
    const url = new URL(fdr_share_form_constants_1.shareLinks[source].apiLink);
    const utmMedium = fdr_share_form_constants_1.shareLinks[source].utm_medium;
    const channelUtm = channelType.replace('_', '-').toLowerCase();
    switch (source) {
        case 'facebook':
            url.searchParams.append(`u`, addUtmParametersToUrl({
                shareUrl,
                utmMedium,
                channelUtm,
            }));
            break;
        case 'twitter':
            if (title)
                url.searchParams.append(`text`, title);
            url.searchParams.append(`url`, addUtmParametersToUrl({
                shareUrl,
                utmMedium,
                channelUtm,
            }));
            break;
        case 'mail':
            if ((email === null || email === void 0 ? void 0 : email.subject) || title)
                url.searchParams.append(`subject`, (email === null || email === void 0 ? void 0 : email.subject) || title);
            const emailBody = decodeURIComponent((email === null || email === void 0 ? void 0 : email.body.replace(/\n/g, '%0D%0A')) || shareUrl);
            url.searchParams.append(`body`, (email === null || email === void 0 ? void 0 : email.body)
                ? emailBody
                : addUtmParametersToUrl({
                    shareUrl: emailBody,
                    utmMedium,
                    channelUtm,
                }));
            if (email === null || email === void 0 ? void 0 : email.bcc)
                url.searchParams.append(`bcc`, email.bcc);
            break;
        case 'whatsapp':
            url.searchParams.append(`text`, addUtmParametersToUrl({
                shareUrl,
                utmMedium,
                channelUtm,
            }));
            url.pathname = '/send';
            break;
    }
    // Replace "+" with space
    return url.toString().replace(/\+/g, ' ');
}
exports.getShareUrl = getShareUrl;
const createUrlWithUtmParameters = (shareUrl, channelType, utmMedium) => {
    const channelUtm = (channelType || '').replace('_', '-').toLowerCase();
    return addUtmParametersToUrl({
        shareUrl,
        utmMedium: utmMedium || `share-button-link`,
        channelUtm,
    });
};
exports.createUrlWithUtmParameters = createUrlWithUtmParameters;
function getIcon(socialLink) {
    return fdr_share_form_constants_1.shareLinks[socialLink].icon;
}
exports.getIcon = getIcon;
//# sourceMappingURL=fdr-share-form.utils.js.map